/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 31 2023
 **/

import { useEffect, useState } from "react";
import { useAtom } from "jotai";

import { GroupPeople, Peoples } from "./atom";
import { usePeople } from "@/frameworks/core/API";

export default function usePeoplePanel() {
	const [loaded, setLoaded] = useState(true);
	const [peoples, setPeoples] = useAtom(Peoples);
	const [groupPeople, setGroupPeople] = useAtom(GroupPeople);
	const peopleAPI = usePeople();

	useEffect(() => {
		const { data: usersData } = peopleAPI.list.result;
		if (!usersData) return;
		const changeUserData = Object.fromEntries(usersData.map((value) => [value.groupId, value.users]));
		if (changeUserData) {
			setGroupPeople(changeUserData);

			const uniqueData = [
				...new Map(
					Object.values(changeUserData)
						.flat()
						?.map((item) => [item.userId, item])
				).values()
			];

			setPeoples(uniqueData);
			setLoaded(false);
		}
	}, [peopleAPI.list.result.data]);

	return {
		loaded,
		people: peoples,
		groupPeople,
		joinGroupIDs:
			peopleAPI.list.result.data && (peopleAPI.list.result.data.map((item) => item.groupId) as string[]),
		joinGroupNames:
			peopleAPI.list.result.data &&
			Object.fromEntries(peopleAPI.list.result.data.map((value) => [value.groupId, value.groupName])),
		relatedUsers: peopleAPI.list.result.data as WebServices.People.List.Data
	};
}
